module.exports = __webpack_public_path__ + "static/img/qnbg.cd4c258.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/doubleQianNiu/qnbg.jpg
// module id = 597
// module chunks = 0